import $ from 'jquery';

const Menu = function () {

  $('.c-header__menu-btn , .js-menuButton').on('click', function (e) {
    $('body').toggleClass('is-ovh');
    $(e.currentTarget).toggleClass('is-active');
    $(e.currentTarget).next('nav').toggleClass('is-active');
    e.preventDefault();
  });
  $(window).on("scroll load", function () {
    let currentPos = $(window).scrollTop();
    let headerHeight = $('.l-header').innerHeight();
    if (currentPos > headerHeight) {
      $(".c-header__menu-btn").addClass('is-move');
    } else if (!$('body').hasClass('is-fixed')) {
      $(".c-header__menu-btn").removeClass('is-move');
    }
    if ($('#js-float') && $(window).scrollTop() === 0) {
      $('#js-toTop').fadeOut();
    } else {
      $('#js-toTop').fadeIn();
    }
  });
}

export default Menu;


// WEBPACK FOOTER //
// ./src/recruit/js/menu.js